// src/hooks/usePaymentGate.js — mission 007 packet 02c.
//
// An email session has no wallet that can sign (canSign false). Every legacy
// ETH payment control (sendPayment / an on-chain write) asks this gate: when
// it is blocked, the control renders disabled with EMAIL_PAYMENT_COPY and the
// payment is never attempted. Credit-balance purchases are not gated: they
// need no signature.
import { useWallet } from '../context/WalletContext';
import { EMAIL_PAYMENT_COPY, EMAIL_SESSION_COPY } from '../config/emailSignIn';

export { EMAIL_PAYMENT_COPY, EMAIL_SESSION_COPY };

export function useWalletPaymentGate() {
  const { authMethod, canSign } = useWallet();
  const blocked = authMethod === 'email' && canSign !== true;
  return { blocked, copy: EMAIL_PAYMENT_COPY };
}
